import { combineReducers } from 'redux';

import { ReducerAction } from 'store/modules/types';
import { UtilsState, Types } from './types';

import listaCep from './endereco/lista-cep/reducer';
import pais from './endereco/pais/reducer';
import consultarDigitais from './consultarDigitais/reducer';
import consultarDigitaisIIRGD from './consultarDigitaisIIRGD/reducer';
import confrontarDigitais from './confrontarDigitais/reducer';
import confrontarDigitaisIIRGD from './confrontarDigitaisIIRGD/reducer';
import confrontarDigitaisCnh from './confrontarDigitaisCnh/reducer';
import enderecoIp from './enderecoIp/reducer';
import consultaCidadesUF from './consultaCidadesUF/reducer';
import consultarFotosRg from './consultarFotosRg/reducer';
import enderecos from './enderecos/reducer';
import baixarArquivos from './arquivos/baixarArquivos/reducer';
import bcadastro from './bcadastro/reducer';
import eventosPPTContabilizacao from './eventosPPT/contabilizacao/reducer';
import uploadArquivo from './uploadArquivo/reducer';

const allReducers = combineReducers({
	listaCep,
	pais,
	consultarDigitais,
	consultarDigitaisIIRGD,
	confrontarDigitais,
	confrontarDigitaisIIRGD,
	confrontarDigitaisCnh,
	enderecoIp,
	consultaCidadesUF,
	consultarFotosRg,
	enderecos,
	baixarArquivos,
	bcadastro,
	eventosPPTContabilizacao,
	uploadArquivo,
});

const combineReducer = (state: UtilsState, action: ReducerAction) => {
	if (action.type === Types.UTILS_CLEAR) {
		return allReducers(undefined, action);
	}

	return allReducers(state, action);
};

export default combineReducer;
